import { useEffect } from "react";

export function usePageMeta(title, description) {
  useEffect(() => {
    document.title = title;
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "description";
      document.head.appendChild(meta);
    }
    meta.content = description;
  }, [title, description]);
}

export const LOGO_URL =
  "https://customer-assets-wrfwihn1.emergentagent.net/job_db16eed4-5d55-47b9-ab5f-967719779844/artifacts/t5gekkxw_ChatGPT%20Image%20Jul%2029%2C%202026%20at%2010_22_15%20PM.png";

export const PHONE = "1 202-830-1293";
export const PHONE_TEL = "tel:+12028301293";
export const EMAIL = "verascreen@theallicockgroup.com";
export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
